import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Alert,
    Box,
    Button,
    Container,
    Grid2 as Grid,
    Skeleton,
    Typography,

    Paper,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { FILE_PATH_URI } from "../../../../utils/helper";
import Icons from "../../../../assets/js/Icons";
import TablePagination from "../../../../components/common/TablePagination";
import { handleRetrieveAllBlogs } from "../../../../redux/public-slices/questionare.slice";
import Images from "../../Home/temp-data/Images";
import SkeletonImage from "../../../../components/ui/SkeletonImage";

function SpecialistDetails() {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);

    const { loadings } = useSelector((state) => state.otherSlice);
    const questionnaire = useSelector((state) => state.authSlice.questionnaire);

    useEffect(() => {
        handleRetrieve();
        // eslint-disable-next-line
    }, []);

    const handleRetrieve = async () => {
        const specIds = [];

        if (questionnaire) {
            if (questionnaire?.areaToImprove)
                specIds.push(questionnaire?.areaToImprove);
            if (questionnaire?.prioritySupportFactor)
                specIds.push(questionnaire?.prioritySupportFactor);

            Object.keys(questionnaire).forEach((key) => {
                if (key.startsWith("reasonForVisit") && questionnaire[key]) {
                    specIds.push(questionnaire[key]);
                }
            });
        }
        const payload = {
            limit: 10,
            currentPage: 1,

            specializationIds: [...new Set(specIds)],
        };
        const response = await dispatch(
            handleRetrieveAllBlogs(payload)
        ).unwrap();

        setData(response || []);
    };


    return (
        <Fragment>
            <Box
                component="section"
                sx={{
                    bgcolor: "dark.main",
                    backgroundSize: "cover",
                    backgroundImage: `url("${Images?.forumImg5}")`,
                    backgroundPosition: { xs: "top left", md: "center" },
                }}
            >
                <Box
                    sx={{
                        bgcolor: "#00000085",
                        py: { xs: 12, lg: 15 },
                    }}
                >
                    <Container maxWidth={false} fixed>
                        <Box
                            sx={{
                                gap: 2.5,
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}
                        >
                            <Typography
                                component="h2"
                                sx={{
                                    color: "white",
                                    fontWeight: "700",
                                    textShadow: "4px 4px 4px #00000073",
                                    textAlign: { xs: "center", md: "start" },
                                    fontSize: { xs: "25px", md: "32px", lg: "45px", xxl: "54px" },
                                }}
                            >Here's Your Personalized Wellness Match
                            </Typography>
                        </Box>
                    </Container>
                </Box>
            </Box>

            <Box sx={{ py: { xs: 5, lg: 10 }, bgcolor: "#f1f1f1" }}>
                <Container maxWidth={false} fixed>
                    <Grid container spacing={4}>
                        {loadings?.retrieveAll ? (
                            new Array(6).fill().map((_, i) => (
                                <Grid key={i} size={4}>
                                    <Skeleton
                                        variant="rectangular"
                                        sx={{
                                            width: '100%',
                                            height: 280,
                                            borderRadius: 1,
                                        }}
                                    />
                                </Grid>
                            ))
                        ) : data?.records?.length === 0 ? (
                            <Grid size={12}>
                                <Alert color="error" severity="error">
                                    No blog Found!
                                </Alert>
                            </Grid>
                        ) : (
                            data?.records?.map((item, i) => (
                                <Grid key={i} size={{ xs: 12, sm: 6, md: 4 }}>
                                    <Paper
                                        sx={{
                                            p: 2,
                                            gap: 3,
                                            height: "100%",
                                            display: "flex",
                                            textAlign: "center",
                                            alignItems: "center",
                                            flexDirection: "column",
                                            boxShadow: "0 0 30px 0 #00000020",
                                            ":hover img": { transform: "scale(1.1)" }
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: "100%",
                                                aspectRatio: "2/1",
                                                overflow: "hidden",
                                                borderRadius: "6px",
                                            }}
                                        >
                                            <SkeletonImage
                                                alt={item?.name}
                                                src={FILE_PATH_URI + item?.banner?.path}
                                                sx={{
                                                    objectFit: "cover",
                                                    transition: "all 500ms ease"
                                                }}
                                            />
                                        </Box>
                                        <Typography
                                            sx={{
                                                color: "#1585db",
                                                fontSize: "20px",
                                                fontWeight: "700",
                                                textDecoration: "none",
                                                transition: "all 500ms ease",
                                            }}
                                        >
                                            {item?.category}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                px: 1,
                                                color: "#7a8a9e",
                                                lineHeight: "28px",
                                                display: "-webkit-box",
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                            }}
                                        >
                                            {item?.name}
                                        </Typography>
                                        <Button
                                            sx={{
                                                mt: "auto",
                                                fontWeight: "400",
                                                border: "1px solid transparent",
                                                ".MuiButton-icon": {
                                                    transition: "all 350ms ease"
                                                },
                                                ":hover": {
                                                    color: "secondary.dark",
                                                    bgcolor: "transparent",
                                                    borderColor: "secondary.dark",
                                                    ".MuiButton-icon": {
                                                        transform: "translateX(3px)"
                                                    }
                                                }
                                            }}
                                            color="secondary"
                                            variant="contained"
                                            to={`/blog/${item?._id}`}
                                            LinkComponent={NavLink}
                                            endIcon={<Icons.ArrowRight2 />}
                                        >
                                            Learn More
                                        </Button>
                                    </Paper>
                                </Grid>




                            ))
                        )}
                    </Grid>
                    <TablePagination
                        pagination={data?.pagination}
                        length={data?.records?.length}
                        loading={loadings?.retrieveAll}
                        cb={handleRetrieve}
                    />
                </Container>
            </Box>
        </Fragment>
    );
}

export default SpecialistDetails;
